import { render, staticRenderFns } from "./PriceSso.vue?vue&type=template&id=da81013e"
import script from "./PriceSso.vue?vue&type=script&lang=js"
export * from "./PriceSso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports